import React, { useState } from 'react';
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { Site, Tag, TagType } from '@juno/client-api/model';
import { DrawerHeader, RightExpandableDrawer } from '@juno/ui';
import { FEATURE_FLAG, useFeatureFlagWithUser } from '@juno/utils';
import TagForm from './TagForm';
import TagTypeForm from './TagTypeForm';

interface CreateTagOrTagTypeFormProps {
  site: Site;
  tags?: Tag[];
  tagTypes?: TagType[];
  handleCancelEdit: () => void;
  refetch: () => void;
  selectedTag?: Tag;
  selectedTagType?: TagType;
  open?: boolean;
}

enum CreateTagVsTypeEnum {
  TAG = 'tag',
  TYPE = 'type',
}

const CreateTagOrTagTypeForm: React.FC<CreateTagOrTagTypeFormProps> = ({
  site,
  tags,
  tagTypes,
  handleCancelEdit,
  refetch,
  selectedTag,
  selectedTagType,
  open,
}) => {
  const [createTagVsType, setCreateTagVsType] = useState<CreateTagVsTypeEnum>(
    CreateTagVsTypeEnum.TAG,
  );
  const { value: directoryTagFiltersValue } = useFeatureFlagWithUser(
    FEATURE_FLAG.DIRECTORY_TAG_FILTERS,
  );
  const title = selectedTag ? 'Edit Tag' : selectedTagType ? 'Edit Tag Type' : 'Create New';

  return (
    <RightExpandableDrawer open={!!open} onClose={() => handleCancelEdit()}>
      <DrawerHeader title={title} />
      {!selectedTag && !selectedTagType && directoryTagFiltersValue && (
        <FormControl sx={{ width: '100%', px: 2, pb: 2, mt: -2 }}>
          <RadioGroup
            row
            sx={{
              justifyContent: 'space-between',
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
            }}
            value={createTagVsType}
            onChange={(e) => {
              setCreateTagVsType(
                e.target.value === CreateTagVsTypeEnum.TAG
                  ? CreateTagVsTypeEnum.TAG
                  : CreateTagVsTypeEnum.TYPE,
              );
            }}
          >
            <FormControlLabel
              value={CreateTagVsTypeEnum.TAG}
              control={
                <Radio
                  inputProps={{
                    'aria-label': 'Radio Tag',
                  }}
                />
              }
              label='Tag'
            />
            <FormControlLabel
              value={CreateTagVsTypeEnum.TYPE}
              control={
                <Radio
                  inputProps={{
                    'aria-label': 'Radio Tag Type',
                  }}
                />
              }
              label='Tag Type'
            />
          </RadioGroup>
        </FormControl>
      )}
      <Box>
        {selectedTagType || createTagVsType === CreateTagVsTypeEnum.TYPE ? (
          <TagTypeForm
            tagTypes={tagTypes}
            site={site}
            handleCancelEdit={handleCancelEdit}
            refetch={refetch}
            initialValues={selectedTagType}
          />
        ) : (
          <TagForm
            tagTypes={tagTypes}
            tags={tags}
            site={site}
            handleCancelEdit={handleCancelEdit}
            refetch={refetch}
            initialValues={selectedTag}
          />
        )}
      </Box>
    </RightExpandableDrawer>
  );
};

export default CreateTagOrTagTypeForm;
